import { render } from "./CookieSettingsPanel.vue?vue&type=template&id=38ef4569&scoped=true"
import script from "./CookieSettingsPanel.vue?vue&type=script&lang=js"
export * from "./CookieSettingsPanel.vue?vue&type=script&lang=js"

import "./CookieSettingsPanel.vue?vue&type=style&index=0&id=38ef4569&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ef4569"]])

export default __exports__